import React, { } from "react";
import homeHeroImg from "../../../images/home/home-page-top-banner.png";

import "./home-banner.scss";
const HomeBanner = () => {
  return (
    <>
      <section className="home-page-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="home-page-hero-container">
                <div className="home-page-hero-inner">
                  <img
                    className="home-page-hero-img"
                    src={homeHeroImg}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeBanner;
